<template>
  <div class="row g-2">
    <div class="row center middle" :style="'aspect-ratio: 3/2; width: 6rem; background-color: #eaeaea;'">
      <ImageComponent v-if="thumbnail" v-bind="thumbnail" />
      <FontAwesomeIcon v-else :icon="['fal', 'drafting-compass']" size="lg" />
    </div>
    <div class="col center">
      <div class="row g-1 middle">
        <strong>{{ item.name }}</strong>
        <img v-if="language" v-bind="language" />
      </div>
      <StatusIndicator v-bind="status" />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { Languages } from '@/components/User/Language'

import ImageComponent from '@/components/Image'
import StatusIndicator from '@/components/StatusIndicator.vue'

export default {
  props: {
    item: Object,
  },
  computed: {
    ...mapState({
      defaultLanguage: ({ enums = {} }) =>
        ((enums.Languages || []).find(({ default: isDefault }) => Boolean(isDefault)) || {}).value,
    }),
    thumbnail() {
      const image = this.$path('item.media.logo')
      if (!image) return

      return {
        src: image.url,
        size: 'contain',
        alt: this.item.name,
        style: `border-radius: var(--border-radius); aspect-ratio: 3/2; min-width: 5rem;`,
      }
    },
    language() {
      const lang = this.$path('item.metadata.language')
      if (lang === this.defaultLanguage || !(lang in Languages)) return

      return { alt: Languages[lang], src: `/images/flags/${lang}.svg`, width: 15 }
    },
    status() {
      if (this.item.isArchived) return { label: this.$t('archived'), status: 'warning' }
      if (this.item.isPublished) return { label: this.$t('published'), status: 'success' }
      return { label: this.$t('unpublished'), status: 'error' }
    },
  },
  components: {
    ImageComponent,
    StatusIndicator,
  },
}
</script>

<style lang="scss"></style>
